<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    class="icon"
    viewBox="0 0 24 24"
  >
    <path d="M11 4H13V20H11V4Z" />
    <path d="M15 7H17V17H15V7Z" />
    <path d="M19 10H21V14H19V10Z" />
    <path d="M7 7H9V17H7V7Z" />
    <path d="M3 10H5V14H3V10Z" />
  </svg>
</template>

<script>
export default {
  name: 'IconEqualizer',
};
</script>

<style scoped>
.icon {
  display: inline-block;
  width: 1.5em;
  height: 1.5em;
  fill: inherit;
  flex-shrink: 0;
}
</style>
